/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { Button, Text } from "components/index";
import { useUI } from "state/UIContext";
import { isNumber } from "utils/capitalize";
import { useOrgData } from "state/OrgDataContext";
import { FC } from "react";
import TermsOfUseAndPolicyModal from "./TermsOfUseAndPolicyModal";
import { useTranslation } from "react-i18next";
const stringify = (k: string) => JSON.stringify(k, null, 2);

type Props = {
  note?: string | string[];
  className?: string;
  hasPolicy?: boolean;
  spacing?: number;
};

const PageNote: FC<Props> = ({ note, className, hasPolicy, spacing = 0 }) => {
  const { t } = useTranslation();
  const { dataContent: EVENT_CONTENT } = useOrgData();
  const { openModal, closeModal } = useUI();
  let paragraph;
  let spacingClass = "space-y-0";
  if (isNumber(spacing)) spacingClass = "space-y-" + spacing;
  if (Array.isArray(note) && note.length > 0) {
    paragraph = note.map((item) => {
      const key = stringify(item);
      return <Text key={key}>{item}</Text>;
    });
  } else if (typeof note === "string") {
    paragraph = <Text>{note}</Text>;
  } else {
    paragraph = "";
  }
  return (
    <div
      className={cn(
        className,
        "flex flex-col -text--theme-colors-text-body",
        spacingClass
      )}
    >
      {paragraph}
      {hasPolicy && (
        <p>
          <Text as="span">{EVENT_CONTENT.pageNote.pleaseReadOurLabel}</Text>
          <Button
            variant="link"
            type="button"
            onClick={() =>
              openModal({
                content: (
                  <TermsOfUseAndPolicyModal
                    type="policy"
                    closeModal={closeModal}
                  />
                ),
              })
            }
            size={"md"}
            className="font-normal !inline-block mx-1 min-h-[auto]"
          >
            {t("guestDetails.privacyPolicy.securityPolicyLabel")}
          </Button>
          <Text as="span">{EVENT_CONTENT.pageNote.pleaseReadOurLabel2}</Text>
        </p>
      )}
    </div>
  );
};
export default PageNote;
